module.exports = __webpack_public_path__ + "img/Common parrotfish.38de86f9.png";